export default function Origin() {
  return (
    <section id="origin" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm text-gray-500 mb-6 tracking-wider">ORIGIN</p>
          <div className="flex justify-end">
            <div className="max-w-2xl">
              <h2 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight mb-8">
                源於關懷<br />
                成就未來<br />
                讓機會走向<br />
                真正需要的人
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                少華獎源於對台灣青年發展與社會流動的長期關懷。在台灣,有許多具備潛力、品格與責任感的年輕人,卻因家庭經濟條件、教育資源或社會支持不足,而難以獲得公平發展的機會。這些青年往往默默努力、堅韌前行,卻缺乏被看見的舞台與實質資源。
              </p>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mt-6">
                少華獎的設立,正是為了填補這道機會落差——讓潛力被看見、讓努力被肯定、讓未來被支持。我們相信,投資一位有志青年,不只是改變一個人的人生,而是影響整個家庭與社會的未來。
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-8">
          <div className="md:col-span-2">
            <div className="rounded-3xl overflow-hidden h-64 md:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/5070700c3cdf2384afedf4128a86a57b.jpg"
                alt="青年畫畫"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="rounded-3xl overflow-hidden h-64 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=young-taiwanese-male-ballet-dancer-performing-solo-on-illuminated-stage-graceful-arabesque-pose-wearing-white-ballet-costume-dramatic-stage-lighting-with-warm-spotlights-dark-background-elegant-movement-professional-dance-photography-inspiring-artistic-performance-wide-angle-stage-view&width=1200&height=600&seq=origin005&orientation=landscape"
                alt="男生芭蕾舞獨舞"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}